<script>
import BrokerageConsoleLayout from '@layouts/brokerage-console-main'
import BrokerageChildInfo from '@components/brokerage-console/child-info'

export default {
  page: {
    title: 'BrokerageConsole::ChildView',
    meta: [{ name: 'description', content: 'BrokerageConsole::ChildView' }],
  },
  components: { BrokerageConsoleLayout, BrokerageChildInfo },
}
</script>

<template>
  <BrokerageConsoleLayout>
    <BrokerageChildInfo
      :brokerage_seq="$route.params.child_seq"
    ></BrokerageChildInfo>
  </BrokerageConsoleLayout>
</template>
